import React from 'react'

export const MailAdd = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_7573)'>
      <path
        d='M22 13.341C20.9317 12.9626 19.7781 12.8945 18.6727 13.1446C17.5674 13.3946 16.5554 13.9527 15.754 14.754C14.9527 15.5554 14.3946 16.5674 14.1446 17.6727C13.8945 18.7781 13.9626 19.9317 14.341 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V13.341ZM12.06 11.683L5.648 6.238L4.353 7.762L12.073 14.317L19.654 7.757L18.346 6.244L12.061 11.683H12.06ZM21 18H24V20H21V23H19V20H16V18H19V15H21V18Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_7573'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
